import {CSSProperties, FC} from 'react';


export interface IIconHeightBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconHeightBmw: FC<IIconHeightBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M15.333 11.667V12c0 .552-.281 1-.833 1H13v-.333a1 1 0 0 1 1-1h1.333ZM11.5 13h-1c-.184 0-.5-.149-.5-.333V12c0-.184.316-.333.5-.333h1.533c.2 0 .467.133.467.333 0 .667-.58 1-1 1ZM6.333 9.667c.38-1.042.823-2 1.867-2h3.6c1.044 0 1.486.958 1.867 2H6.333Zm3.667 3c0 .184-.316.333-.5.333h-1c-.42 0-1-.333-1-1 0-.2.267-.333.467-.333H9.5c.184 0 .5.149.5.333v.667ZM7 13H5.5c-.552 0-1.167-.448-1.167-1v-.333H6a1 1 0 0 1 1 1V13Zm8.667-3.158c.286-.087.333-.259.333-.459S15.865 9 15.6 9h-1.267C13.467 7.667 13 7 11.6 7H8.4C7 7 6.533 7.667 5.667 9H4.4c-.265 0-.4.184-.4.383 0 .2.047.372.333.459l.934.196L4 11v4.333c0 .369.299.667.667.667h1a.667.667 0 0 0 .666-.667V15h7.334v.333c0 .369.298.667.666.667h1a.667.667 0 0 0 .667-.667V11l-1.267-.962.934-.196Z" clipRule="evenodd" />
            <path d="M3 4H21V5H3z" />
            <path d="M3 19H21V20H3z" />
            <path d="M19 7h1v10h-1V7Z" />
            <path d="m19.5 6 1.299 1.5h-2.598L19.5 6ZM19.5 18l-1.299-1.5h2.598L19.5 18Z" />
        </svg>
    );
};
